import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const BusinessTravel = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Business Travel - Polify Travels"
        fallbackDescription="Smart, seamless business travel solutions by Polify Travels. Corporate travel made easy for individuals, executives, and teams."
        fallbackKeywords="business travel, corporate travel, executive travel, flight bookings, hotel reservations, Polify Travels"
        fallbackOgTitle="Business Travel - Polify Travels"
        fallbackOgDescription="Efficient, reliable, and seamless business travel solutions for professionals and companies."
        fallbackCanonicalUrl="https://poliflytravels.com/business-travel/"
      />
      <CommonBanner
        heading="Business Travel"
        img={ImageConstants.visabanner}
        pagination="Business Travel"
      />
      <section className="business-travel-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polify Travels – Your Trusted Partner for Smart Business Travel</h2>
                <p className="lead">Simplifying Business Travel, So You Can Focus on What Matters</p>
                <p>At Polify Travels, we know that in business, every second counts. That's why we offer efficient, reliable, and seamless corporate travel solutions tailored for individuals, executives, and teams so you can stay focused on your goals, not your itinerary.</p>
                <div className="mb-5">
                  <h3 className="mb-3">Corporate Travel Made Easy</h3>
                  <p>From domestic client meetings to international business trips, we manage your travel with precision and professionalism. Our dedicated team ensures each journey is smooth, timely, and stress-free.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Our Business Travel Services Include:</h3>
                  <ul className="benefits-list">
                    <li>Domestic & international flight bookings</li>
                    <li>Hotel reservations near business hubs & event venues</li>
                    <li>Airport transfers and executive chauffeur services</li>
                    <li>Last-minute booking and emergency support</li>
                    <li>Visa consultation and travel documentation assistance</li>
                    <li>Custom corporate travel plans for individuals or teams</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">Why Choose Polify Travels?</h3>
                  <ul className="benefits-list">
                    <li>Fast, flexible booking and personalized support</li>
                    <li>Transparent pricing – no hidden fees or delays</li>
                    <li>Trusted by entrepreneurs, professionals, and companies</li>
                    <li>24/7 travel assistance while you're on the move</li>
                  </ul>
                </div>  
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Whether it's a quick seminar or an extended overseas assignment, Polify Travels takes care of all the logistics so you can travel smart and work efficiently.</h3>
                  <p><strong>Polify Travels – Powering Productive Journeys.</strong></p>
                </div> </div>
         
          </div>
         
        </div>
      </section>
    </>
  );
};

export default BusinessTravel;